import React from "react";

export default function ColorFrame32({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <rect
          width="83.168"
          height="66.24"
          x="176.712"
          y="114.08"
          fill="#725A6E"
          rx="27.968"
        ></rect>
        <rect
          width="61.088"
          height="36.064"
          x="184.072"
          y="129.536"
          fill="#fff"
          rx="14.72"
        ></rect>
        <path
          fill="#EFD3CC"
          d="M17 92.736a7.36 7.36 0 017.36-7.36h191.36a7.36 7.36 0 017.36 7.36v51.695c0 56.811-46.054 102.865-102.865 102.865C63.211 247.296 17 201.085 17 144.081V92.736z"
        ></path>
        <rect
          width="116.176"
          height="115.44"
          x="61.216"
          y="102.36"
          fill="#fff"
          stroke="#725A6E"
          strokeWidth="6"
          rx="57.72"
        ></rect>
        <path
          fill="#725A6E"
          d="M23.624 241.323c0-.766.621-1.387 1.387-1.387H215.07c.766 0 1.387.621 1.387 1.387 0 19.152-15.525 34.677-34.677 34.677H58.301c-19.152 0-34.677-15.525-34.677-34.677zM106.955 22.665C120.126 10.923 111.216 0 111.216 0s20.145 12.015 7.748 29.219c-4.605 6.39-4.702 12.277-1.937 17.477 3.141 5.908 5.662 8.006 8.135 13.38 3.752 8.156-7.36 16.658-10.072 17.204 1.077-2.544 1.22-6.676.775-8.192-2.324-7.92-10.461-11.742-15.497-17.75-4.617-5.509-9.866-14.005 6.587-28.673z"
        ></path>
        <path
          fill="#725A6E"
          d="M130.362 30.35c8.673-7.716 2.806-14.894 2.806-14.894s13.266 7.896 5.102 19.201c-3.033 4.2-3.096 8.068-1.276 11.485 2.069 3.883 3.729 5.261 5.358 8.793 2.471 5.36-4.847 10.946-6.633 11.305.709-1.672.804-4.387.51-5.383-1.53-5.204-6.888-7.717-10.205-11.665-3.041-3.62-6.497-9.203 4.338-18.842z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
